<template>
    <div class="container">
        <div class="row my-5">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <form v-if="user">
                            <dl class="row mb-0">
                                <dt class="col-lg-8 col-md-6 col-12">
                                    <h3 class="mb-3 nav-settings-head text-dark-green">Reset Password</h3>
                                </dt>
                                <dd class="col-lg-4 col-md-6 col-12">
                                    <button @click.prevent="sendRecoveryLink" :class="`form-control loadn btn btn-${color}`">
                                        <span class="hide-on-mobile">{{msg}}</span>
                                        <span class="hide-on-desktop">{{msg.split(" ")[msg.split(" ").length - 2]}} {{msg.split(" ")[msg.split(" ").length - 1]}}</span>
                                    </button>
                                </dd>
                            </dl>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "Password",
    data() {
        return {
            msg: 'Email me a password reset link',
            color: 'warning'
        }
    },
    methods: {
        ...mapActions(['recoveryLink', 'createTransaction']),
        sendRecoveryLink() {
            let userObj = {
                email: this.user.email
            }
            this.recoveryLink(userObj)
            .then((data) => {
                if(!data.error){
                    this.color = "dark-green"
                    let eventObj = {
                        userId: this.user._id,
                        event: "requested account-password reset link"
                    }
                    this.createTransaction(eventObj).then(() => {}).catch((e) => {})
                }
                this.msg = data.msg
            }).catch((e) => {
                this.color = "danger"
                this.msg = "Unable to email you a reset link, try again."
            })
        }
    },
    computed: {
        ...mapGetters(['user'])
    }
}
</script>